import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const legalRecordSessionLocaleModule: LocaleModule = {
  name: "legalRecordSession",
  messages: { en: en, it: it },
};
